import { LANGUAGES, SupportedLanguage } from "@next-platform/client-common-core";
import { useLocation, useParams } from "react-router-dom";

const useLocalizedLocation = () => {
  const location = useLocation();
  const params = useParams();

  const languageCodeInUrl = params.lang || null;

  let normalizedPath = location.pathname;

  if (languageCodeInUrl) {
    normalizedPath = normalizedPath.replace(`/${languageCodeInUrl}`, "") || "/";
  }
  return {
    ...location,
    languageCode: languageCodeInUrl as SupportedLanguage | null,
    pagePath: normalizedPath,
    isSupportedLang: languageCodeInUrl ? (LANGUAGES[languageCodeInUrl as SupportedLanguage] ? true : false) : true, // null lang is considered supported (default lang)
  };
};

export default useLocalizedLocation;
